import React from 'react';

function Link3(props) {
	return (
		<svg height="50" width="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
	<g fill="#000">
		<path d="M10.43 11.12c-1.92 0-3.47 1.56-3.48 3.47v11.12c0 1.92 1.56 3.47 3.48 3.48h16.68c1.92 0 3.47-1.56 3.47-3.48a2.08 2.08 0 0 1 4.17 0 7.64 7.64 0 0 1-7.64 7.65h-16.68a7.64 7.64 0 0 1-7.65-7.65v-11.12a7.64 7.64 0 0 1 7.65-7.64h16.68c2.88 0 5.39 1.59 6.69 3.94a2.08 2.08 0 0 1-3.65 2.02 3.47 3.47 0 0 0-3.05-1.79h-16.68z" fill="#000" fillRule="evenodd"/>
		<path d="M22.94 20.85c-1.92 0-3.47 1.56-3.48 3.47a2.08 2.08 0 0 1-4.17 0 7.64 7.64 0 0 1 7.65-7.64h16.68a7.64 7.64 0 0 1 7.64 7.64v11.12a7.64 7.64 0 0 1-7.64 7.65h-16.68a7.64 7.64 0 0 1-6.69-3.94 2.08 2.08 0 1 1 3.65-2.02c0.59 1.07 1.73 1.79 3.04 1.79h16.68c1.92 0 3.47-1.56 3.47-3.48v-11.12c0-1.92-1.56-3.47-3.47-3.47h-16.68z" fill="#000" fillOpacity="0.4" fillRule="evenodd"/>
	</g>
</svg>
	);
};

export default Link3;